module.exports = __webpack_public_path__ + "assets/img/32_529_big.784c995a.jpg";